export default __webpack_public_path__ + "static/media/kangoo-gallery-9.78410188.jpg";